import React from 'react';
import FeedBackForm from './FeedBackForm';
import { BodySmall, Heading6 } from '../common/GlobalElements/Typography';

export default function Average(props) {
    return (
        <>
            <div className="tab-pane fade" id="average" role="tabpanel" aria-labelledby="pills-contact-tab">
                <div className="tab-pane-head">
                    <Heading6>
                        <span>Thanks </span> for your rating.
                    </Heading6>
                    <BodySmall>
                        Please let us know how we could have got 5 stars. Is there anything we could have improved on?
                    </BodySmall>
                </div>
                <FeedBackForm rating_type={props.rating_type} />
            </div>
        </>
    );
}
